export enum ActionTypes {
  CHANGE_GEOFENCE_ADDRESS_REQUEST = 'CHANGE_GEOFENCE_ADDRESS_REQUEST',
  CHANGE_GEOFENCE_ADDRESS_SUCCEEDED = 'CHANGE_GEOFENCE_ADDRESS_SUCCEEDED',
  CHANGE_GEOFENCE_COORDINATE_REQUEST = 'CHANGE_GEOFENCE_COORDINATE_REQUEST',
  CHANGE_GEOFENCE_COORDINATE_SUCCEEDED = 'CHANGE_GEOFENCE_COORDINATE_SUCCEEDED',
  CLEAR_GEOFENCE = 'CLEAR_GEOFENCE',
}
